import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    CardBody,
    Row,
    Col,
    Card,
    Container,
    Form,
    Alert,
    Label,
    Input,
    Spinner,
    Button
} from "reactstrap";

// Import components and utilities
import { usePDFExport } from './ExportPDF';
import { usePocketBase } from '../../../PocketBaseContext';
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import logo from "../../../assets/images/logo.png";

// Import existing components
import GetProducts from "./GetProducts";
import GetCustomerInfo from "./GetCustomerInfo";
import GetAndSelectNotes from "./GetAndSelectNotes";
import VersionHistoryTable from './VersionHistoryTable';

import {

    getVersionHistory,

} from './versionHandler';

const ReformInvoiceView = () => {
    document.title = "Teklif Detay | Reform Panel";
    const { id } = useParams();
    const navigate = useNavigate();
    const pb = usePocketBase();


    // Loading and error states
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isUpdatingRates, setIsUpdatingRates] = useState(false);
    const [rateUpdateStatus, setRateUpdateStatus] = useState(null);

    // Form states
    const [title, setTitle] = useState('');
    const [customerInfo, setCustomerInfo] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedNotes, setSelectedNotes] = useState([]);
    const [exchangeRates, setExchangeRates] = useState(null);
    const [totals, setTotals] = useState({});
    const [displayCurrency, setDisplayCurrency] = useState('TRY');
    const [status, setStatus] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [validUntil, setValidUntil] = useState('');
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [invoiceNumber, setInvoiceNumber] = useState('');

    // Version management states
    const [versionHistory, setVersionHistory] = useState([]);
    const [versionNote, setVersionNote] = useState('');
    const [showVersionModal, setShowVersionModal] = useState(false);
    const [currentInvoice, setCurrentInvoice] = useState(null);

    // Status options
    const statusOptions = [
        { value: 'Taslak', label: 'Taslak' },
        { value: 'Beklemede', label: 'Beklemede' },
        { value: 'Onaylandı', label: 'Onaylandı' },
        { value: 'Reddedildi', label: 'Reddedildi' },
        { value: 'İptal Edildi', label: 'İptal Edildi' }
    ];

    // Initial data fetch
    useEffect(() => {
        const fetchInvoiceData = async () => {
            try {
                setIsLoading(true);
                // Expand ile customer ve contacts bilgilerini birlikte alalım
                const record = await pb.collection('invoices').getOne(id, {
                    expand: 'customer,selected_contacts'
                });

                console.log('Fetched record:', record);

                // Form fields
                setTitle(record.title || '');
                setInvoiceNumber(record.invoice_number || '');
                setStatus(record.status || 'Taslak');

                // Customer Info - expand edilmiş veriyi kullanalım
                if (record.expand?.customer) {
                    setCustomerInfo(record.expand.customer);
                }

                // Selected Contacts - expand edilmiş veriyi kullanalım
                if (record.expand?.selected_contacts) {
                    setSelectedContacts(Array.isArray(record.expand.selected_contacts)
                        ? record.expand.selected_contacts
                        : [record.expand.selected_contacts]);
                }

                // Products
                if (record.products) {
                    const parsedProducts = typeof record.products === 'string'
                        ? JSON.parse(record.products)
                        : record.products;
                    setSelectedProducts(parsedProducts);
                }

                // Notes
                if (record.notes) {
                    const parsedNotes = typeof record.notes === 'string'
                        ? JSON.parse(record.notes)
                        : record.notes;
                    setSelectedNotes(parsedNotes);
                }

                // Totals
                if (record.total_amount) {
                    const parsedTotals = typeof record.total_amount === 'string'
                        ? JSON.parse(record.total_amount)
                        : record.total_amount;
                    setTotals(parsedTotals);
                }

                // Dates
                setInvoiceDate(record.exchange_rate_date ? new Date(record.exchange_rate_date).toISOString().split('T')[0] : '');
                setDueDate(record.due_date ? new Date(record.due_date).toISOString().split('T')[0] : '');
                setValidUntil(record.valid_until ? new Date(record.valid_until).toISOString().split('T')[0] : '');

                setCurrentInvoice(record);

                // Version history ve exchange rates
                await Promise.all([
                    getVersionHistory(pb, record.id).then(setVersionHistory),
                ]);

            } catch (error) {
                console.error('Error fetching invoice:', error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchInvoiceData();
        }
    }, [id, pb]);

    //pdf Download ! 
    const { exportToPDF } = usePDFExport();



    const [isDownloading, setIsDownloading] = useState(false);

    const handlePDFDownload = async () => {
        let clonedButtonCardBody = null;

        try {
            console.log('PDF Download started');

            // Validate required data
            if (!invoiceNumber) {
                setRateUpdateStatus({
                    type: 'error',
                    message: 'Fatura numarası eksik. Lütfen formu kontrol edin.'
                });
                return;
            }

            // Create a clone of the entire CardBody containing buttons
            const originalButtonCardBody = document.querySelector('.p-4.pdf-hide');
            if (!originalButtonCardBody) {
                throw new Error('Buttons container not found');
            }

            // Create a temporary clone to preserve original state
            clonedButtonCardBody = originalButtonCardBody.cloneNode(true);

            // Remove original buttons container from DOM
            originalButtonCardBody.remove();

            const currentData = {
                title,
                invoiceNo: invoiceNumber,
                date: invoiceDate,
                status: status,
                customerInfo,
                selectedProducts,
                selectedNotes,
                exchangeRates,
                totals
            };

            console.log('Current PDF data:', currentData);

            // Ensure the invoice form exists
            const invoiceForm = document.getElementById('invoice_form');
            if (!invoiceForm) {
                throw new Error('Invoice form not found');
            }

            // Add a short delay to ensure UI update
            await new Promise(resolve => setTimeout(resolve, 300));

            // Export PDF
            await exportToPDF(currentData);

            console.log('PDF Export successful');

            // Optional: Show success message
            setRateUpdateStatus({
                type: 'success',
                message: 'PDF başarıyla oluşturuldu.'
            });

        } catch (error) {
            console.error('PDF indirme sırasında hata:', error);
            setRateUpdateStatus({
                type: 'error',
                message: `PDF oluşturma hatası: ${error.message}`
            });
        } finally {
            // Find the parent container to restore buttons
            const formElement = document.getElementById('invoice_form');
            if (formElement && clonedButtonCardBody) {
                // Re-append the cloned buttons container
                formElement.appendChild(clonedButtonCardBody);
            }
        }
    };




    // Loading state
    if (isLoading) {
        return (
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
                        <Spinner color="primary" />
                    </div>
                </Container>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="page-content">
                <Container fluid>
                    <Alert color="danger">
                        Teklif yüklenirken hata oluştu: {error}
                    </Alert>
                    <Button color="primary" onClick={() => navigate('/reform-invoices')}>
                        Tekliflere Dön
                    </Button>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Teklif Görüntüleme" pageTitle="Teklifler" />

                {/* Status alerts */}
                {rateUpdateStatus && (
                    <Alert
                        color={rateUpdateStatus.type === 'success' ? 'success' : 'danger'}
                        toggle={() => setRateUpdateStatus(null)}
                        isOpen={!!rateUpdateStatus}
                    >
                        {rateUpdateStatus.message}
                    </Alert>
                )}


                {/* Main content */}
                <Row className="justify-content-center">
                    <Col xxl={9}>
                        <Card>
                            <Form className="needs-validation" id="invoice_form">
                                {/* Company Header */}
                                {/* Company Header */}
                                <CardBody className="p-4 border-bottom border-bottom-dashed">
                                    <Row className="flex">
                                        <Col lg={4}>
                                            <div className="text-left">
                                                <img
                                                    src={logo}
                                                    alt="Reform Yangın Logo"
                                                    className="mb-4"
                                                    style={{ maxWidth: '250px' }}
                                                />
                                                <div className="address-section">
                                                    <p className="text-gray-600 mb-2"><strong>ADRES</strong></p>
                                                    <p className="mb-1">Pınartepe Mahallesi Mayıs Sokak No:7/18</p>
                                                    <p className="mb-1">Büyükçekmece / İSTANBUL</p>
                                                    <p>Posta Kodu: 34500</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={8}>
                                            <div className="text-end">
                                                <h5 style={{ marginTop: '55px' }}>
                                                    <strong>Reform Yangın ve Yapı Teknolojileri Ltd. Şti.</strong>
                                                </h5>
                                                <p><strong>Vergi Dairesi/No:</strong> Büyükçekmece - 734 212 2268</p>
                                                <p><strong>Email:</strong> info@reformyangin.com</p>
                                                <p><strong>Website:</strong> www.reformyangin.com</p>
                                                <p><strong>Tel:</strong> 0850 888 19 81</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>

                                {/* Title */}
                                <CardBody className="p-4">
                                    <Row className="justify-content-center">
                                        <Col lg={8}>
                                            <div className="mb-3 text-center">
                                                <Input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    disabled={!isEditing}
                                                    style={{
                                                        fontSize: '16px',
                                                        fontWeight: '500'
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>

                                {/* Customer Info Edited and working */}
                                <CardBody className="p-4 border-top border-top-dashed">
                                    <GetCustomerInfo
                                        customerInfo={customerInfo}
                                        selectedContacts={selectedContacts}
                                        currentInvoice={currentInvoice}
                                        isEditing={isEditing}
                                        setCurrentInvoice={setCurrentInvoice}
                                    />
                                </CardBody>

                                {/* Products */}
                                <CardBody className="p-4 border-top border-top-dashed">
                                    <GetProducts
                                        initialProducts={selectedProducts}
                                        isEditing={isEditing}
                                        disabled={!isEditing}
                                        totals={currentInvoice?.total_amount} // Direkt total_amount kullanıyoruz
                                    />
                                </CardBody>

                                {/* Notes */}
                                <CardBody className="p-4 border-top border-top-dashed">
                                    <GetAndSelectNotes initialNotes={currentInvoice?.notes || []} />
                                </CardBody>

                                {/* Action Buttons */}

                                <CardBody className="p-4 pdf-hide">
                                    <div className="hstack gap-2 justify-content-end">
                                        <Button color="primary" onClick={() => navigate(`/reform-invoices/detail/${id}`)}>
                                            <i className="ri-pencil-fill align-bottom me-1"></i>
                                            Düzenle
                                        </Button>
                                        <Button color="info" onClick={handlePDFDownload}>
                                            <i className="ri-download-2-line align-bottom me-1"></i>
                                            PDF İndir
                                        </Button>
                                    </div>
                                </CardBody>

                            </Form>
                        </Card>

                        {/* Version History */}
                        {versionHistory.length > 0 && (
                            <VersionHistoryTable
                                versionHistory={versionHistory}
                                onRefresh={() => { }}
                            />
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ReformInvoiceView;